/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Role_InkubatorInputs */

const en_cp_role_inkubator = /** @type {(inputs: Cp_Role_InkubatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incubator / student affairs / research office`)
};

const id_cp_role_inkubator = /** @type {(inputs: Cp_Role_InkubatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkubator / kemahasiswaan / LPPM`)
};

/**
* | output |
* | --- |
* | "Incubator / student affairs / research office" |
*
* @param {Cp_Role_InkubatorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_role_inkubator = /** @type {((inputs?: Cp_Role_InkubatorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Role_InkubatorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_role_inkubator(inputs)
	return en_cp_role_inkubator(inputs)
});